import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { design, forget, Login_img, signup } from "../../../assets/img";
import PersonIcon from '@mui/icons-material/Person';
import HttpsIcon from '@mui/icons-material/Https';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useNavigate } from "react-router-dom";
import EmailIcon from '@mui/icons-material/Email';


const ForgetPassword = () => {
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = (data) => {
        console.log("Login Data :", data);
    };
    const [showPassword, setShowPassword] = useState(false);
    const [confirmPassword, setConfimPassword] = useState(false);

    const togglePassword = () => {
        setShowPassword((prev) => !prev);
    };

    const ConfirmPassword = () => {
        setConfimPassword((prev) => !prev);
    };


    return (
        <div className="login-container d-flex ac-jc">

            <div className="left-side">
                <div className="left-box">

                    <h1 className="f4 fs-30 mb-20">Forget Password</h1>

                    <form onSubmit={handleSubmit(onSubmit)}>

                        <div className="input-group my-2">
                            <label className="f3 fs-14">Password</label>

                            <div className="input-box">
                                <HttpsIcon className="input-icon" />
                                <input
                                    type="password"
                                    placeholder="Enter your Password"
                                    {...register("password", { required: "Password is required" })}
                                />
                                    <span className="focus-line"></span>
                                {showPassword ? (
                                    <VisibilityOffIcon className="view-icon" onClick={togglePassword} />
                                ) : (
                                    <VisibilityIcon className="view-icon" onClick={togglePassword} />
                                )}
                            </div>

                            {errors.password && (
                                <span className="error-text">{errors.password.message}</span>
                            )}
                        </div>
                        <div className="input-group ">
                            <label className="f3 fs-14"> Confirm Password</label>

                            <div className="input-box">
                                <HttpsIcon className="input-icon" />
                                <input
                                    type="confirmpassword"
                                    placeholder="Enter confirm password"
                                    {...register("password", { required: "confirm password is required" })}
                                />
                                    <span className="focus-line"></span>
                                {confirmPassword ? (
                                    <VisibilityOffIcon className="view-icon" onClick={ConfirmPassword} />
                                ) : (
                                    <VisibilityIcon className="view-icon" onClick={ConfirmPassword} />
                                )}
                            </div>

                            {errors.password && (
                                <span className="error-text">{errors.password.message}</span>
                            )}
                        </div>


                        <button type="submit" className="login-btn f4 fs-16 my-3 ">
                            Save Password
                        </button>

                    </form>



                </div>
            </div>

            <div className="right-side">
                <img src={forget} alt="login" className="login-img" />
            </div>

        </div>
    );
};

export default ForgetPassword;
